/**
 * Requêtes dérivées des sanctions, hors liste principale : sans elles, les
 * onglets équipe / rapports / amendes, la frise de suspension d'un joueur et
 * l'état « PV publié » des sanctions restaient figés jusqu'au staleTime après
 * une saisie. Partagé avec le gestionnaire temps réel (useGlobalRealtime) et
 * les affaires du PV (useTypedCase).
 */
export const SANCTION_DERIVED_QUERY_KEYS = [
    "teamSanctions",
    "disciplinaryReportsSummary",
    "teamFinesSummary",
    "playerSuspensionTimeline",
    "playerSuspensionSummary",
    "sanctionPvStatus",
    "motifAccumulationStatus",
    "yellowSeriesStatus",
] as const;
